import { gql } from "@apollo/client";

export const updateSiteIncidentStatusMutation = gql`
mutation($input: SiteIncidentStatusInput!){
  updateSiteIncidentStatus(input: $input) {
    response
    message
  }
}
`;